import { TourStep } from '../../models/tour.model';

export const NOTE_ACTIONS_TOUR: TourStep[] = [
  {
    title: 'Working with a note',
    element: 'semeris-conversation-activity-item',
    intro: `
      <p>In this tour, we'll utilize a <b>note example</b> where a concern was raised and multiple colleagues collaborated for a resolution.</p>
      <p><i>Using this example, let's explore the available options.</i></p>
    `,
  },
  {
    title: 'Quick Actions',
    element: 'semeris-conversation-activity-item semeris-comment-item .comment-meta',
    intro: `
        <p>Below notes and replies you can see <b>who</b> posted the content and <b>when</b>.</p>
        <p>You will also see <b>action icons</b> for quick access to various options.</p>
        <p><i><b>Be aware!</b> In this tour, for clarity, all icons are visible. However, in actual use, they appear only when you <b>hover over the area</b> with the mouse. This design reduces clutter and lets you better focus on your notes.</i></p>
      `,
  },
  {
    title: 'Show more/less context',
    element:
      'semeris-conversation-activity-item semeris-comment-item .quick-actions mat-icon#comment-action-toggle',
    intro: `
        <p>The <i class="material-icons">expand_more</i> and <i class="material-icons">expand_less</i> icons show more/less context. A note initially shows only the most important information to save space.</p>
      `,
  },
  {
    title: 'Editing a note',
    element:
      'semeris-conversation-activity-item semeris-comment-item .quick-actions mat-icon#comment-action-edit',
    intro: `
        <p>The <b>edit</b> <i class="material-icons">edit</i> icon lets you edit the note, but only if you have created it.</p>
      `,
  },
  {
    title: 'Deleting a note',
    element:
      'semeris-conversation-activity-item semeris-comment-item .quick-actions mat-icon#comment-action-delete',
    intro: `
      <p>You can <b>delete</b> your own notes with the <i class="material-icons">delete</i> icon.</p>
    `,
  },
  {
    title: 'Assigning a note',
    element:
      'semeris-conversation-activity-item semeris-comment-item .quick-actions semeris-assignee-editor',
    intro: `
      <p>Assign one or more people to this note using the <i class="material-icons">person_pin</i>.</p>
      <p>Clicking on the assignees <i class="material-icons" style="color: var(--grey-icon-color);">person_pin</i> in the bottom also lets you change the assignees.</p>
    `,
  },
  {
    title: 'Editing labels',
    element:
      'semeris-conversation-activity-item semeris-comment-item .quick-actions semeris-conversation-label-editor',
    intro: `
      <p>Labels help you organize your notes.</p>
      <p><b>Add/remove labels</b> using the Label <i class="material-icons">label</i> icon.</p>
      <p>You can also just click any label to open the label editor.</p>
  `,
  },
  {
    title: 'Reply to a note',
    element:
      'semeris-conversation-activity-item semeris-comment-item .quick-actions mat-icon#comment-action-reply',
    intro: `
      <p>Join the conversation using the Reply <i class="material-icons">reply</i> icon.</p>
    `,
  },
  {
    title: 'Options menu',
    element: 'semeris-conversation-activity-item semeris-comment-item .comment-actions mat-icon',
    intro: `
        <p>You can access the same actions through the three-dot <i class="material-icons">more_vert</i> menu. While using this menu helps familiarize you with the features, the quick action icons are usually faster.</p>
    `,
  },
  {
    title: 'Working with Notes',
    element: 'semeris-conversation-activity-item',
    intro: `
      <p>Let's recap:</p>
      <ul>
        <li><b>Contextualize</b> - understand the original context from anchors and snippets</li>
        <li><b>Organize</b> - label notes and assign them to someone</li>
        <li><b>Organize</b> - add labels and assign notes to colleagues</li>
        <li><b>Collaborate</b> - reply to notes and discuss</li>
      </ul>
      <p><i>This concludes our tour. Remember, collaboration is the key to success!</i></p>
    `,
  },
];
